export enum StickerSetType {
  Emoji = 1,
  Sticker = 2,
  Custom = 3,
}

export enum StickerCategory {
  Emoji = 'emoji',
  Sticker = 'sticker',
}

export interface StickerSet {
  count: number;
  created_at: number;
  logo: string;
  parent_set_id: string;
  remote_version: string;
  set_id: string;
  set_type: StickerSetType;
  short_name: string;
  sub_set_type: number;
  title: string;
  updated_at: number;
  version: string;
}

export interface StickerSetItem {
  id: string;
  set_id: string;
  extra: string;
  emoji_id: string;
  category: StickerCategory;
  render_data: Record<string, any>;
  created_at: number;
  updated_at: number;
}

export interface StickerData {
  category: StickerCategory;
  created_at: number;
  emoji_id: string;
  extra: string;
  id: string;
  render_data: Record<string, any>;
  set_id: string;
  updated_at: number;
}

export type StickerDownloadResult = Pick<StickerData, 'id' | 'render_data'>;
